import i18n from '../i18n'
import {
  normalizeAppLanguage,
  type AppLanguage,
} from './documentLocale'

export {
  applyDocumentDirection,
  getSortLocale,
  isRtlLanguage,
  normalizeAppLanguage,
  SUPPORTED_LANGUAGES,
  type AppLanguage,
} from './documentLocale'

export function getCurrentAppLanguage(): AppLanguage {
  return normalizeAppLanguage(i18n.language)
}

export function getApiAcceptLanguage(): AppLanguage {
  return getCurrentAppLanguage()
}
